interface CreateMarkerOptions extends google.maps.MarkerOptions {
    onClick?: () => void;
}

export const storeMarkerIcon = (url: string) =>
    ({
        url,
        scaledSize: new google.maps.Size(24, 35),
    }) as google.maps.Icon;

export const createMarker = ({
    icon,
    position,
    title,
    label,
    zIndex = 1,
    onClick,
    visible,
}: CreateMarkerOptions) => {
    const marker = new google.maps.Marker({
        position,
        icon,
        zIndex,
        title,
        label,
        visible,
    });

    if (onClick) {
        marker.addListener("click", onClick);
    }

    return marker;
};
